module.exports = __webpack_public_path__ + "img/ingresos-netos.9bd72ef4.png";